import FleetTitle from '@/libs/antd/components/Title';
import { Button, Spin, Table } from 'antd';
import { FC } from 'react';
import dayjs from 'dayjs';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useApp } from '@/App';
import { useGetMKLDetail } from '@/libs/fleet-api/services/mkl';

type MKLHistorySPFPageProps = {
	spfId: number;
	onBack?: () => void;
};

const MKLHistorySPFPage: FC<MKLHistorySPFPageProps> = ({ spfId, onBack }) => {
	const { navigate } = useApp();

	const detailQuery = useGetMKLDetail({ mklId: spfId });
	const historyData = detailQuery.data?.data?.spfApprovalHistory;
	const isLoading = detailQuery.isLoading;

	if (isLoading) {
		return (
			<div style={{ display: 'flex', justifyContent: 'center', padding: 40 }}>
				<Spin size="large" />
			</div>
		);
	}

	const dataSource =
		historyData?.map((item, index) => ({
			...item,
			key: index + 1,
		})) ?? [];

	return (
		<div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
			<div style={{ display: 'flex', gap: 10, marginBottom: 10 }}>
				<div>
					{typeof onBack === 'function' && (
						<button
							style={{
								display: 'flex',
								height: 44,
								width: 44,
								fontSize: 24,
								border: 'none',
								alignItems: 'center',
								justifyContent: 'center',
								background: '#1557BC',
								color: 'white',
								cursor: 'pointer',
							}}
							onClick={onBack}
						>
							<ArrowLeftOutlined />
						</button>
					)}
				</div>
				<div style={{ flex: 1 }}>
					<FleetTitle marginBottom={0}>History SPF</FleetTitle>
				</div>
			</div>

			<Table
				bordered
				scroll={{ x: 'max-content' }}
				pagination={false}
				dataSource={dataSource}
				columns={[
					{
						title: 'No',
						align: 'center',
						width: 50,
						render: (_, __, index) => index + 1,
					},
					{
						title: 'No. SPF',
						dataIndex: 'spfNo',
						render: (value: string, record) =>
							value ? (
								<a
									href="#"
									onClick={(e) => {
										e.preventDefault();
										navigate('SPFPage', {
											spfId: record.spfId,
											napResolutionId: 0,
											onBack: () =>
												navigate('MKLHistorySPFPage', { spfId, onBack }),
											viewOnly: true,
										});
									}}
								>
									{value}
								</a>
							) : (
								'-'
							),
					},
					{
						title: 'Name',
						dataIndex: 'name',
						render: (value: string) => value || '-',
					},
					{
						title: 'Date',
						dataIndex: 'date',
						render: (value: string) =>
							value ? dayjs(value).format('DD/MM/YYYY') : '-',
					},
					{
						title: 'Process',
						dataIndex: 'process',
						render: (value: string) => value || '-',
					},
					{
						title: 'Status',
						dataIndex: 'status',
						render: (value: string) => value || '-',
					},
					{
						title: 'Approval Notes',
						dataIndex: 'notes',
						render: (value: string) => value || '-',
					},
				]}
			/>

			{typeof onBack === 'function' && (
				<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
					<Button onClick={onBack}>BACK</Button>
				</div>
			)}
		</div>
	);
};

export default MKLHistorySPFPage;
